module.exports = __webpack_public_path__ + "img/21.88ee1b4a.jpg";